/** @jsxImportSource @emotion/react */
/* eslint-disable react/no-unused-prop-types */
import React from "react";
import PropTypes from "prop-types";
import { css } from "@emotion/react";
import { Alert as AlertBase } from "reactstrap";

class Alert extends React.Component {
  constructor(props) {
    super(props);

    const messages = this.normalizeMessages(props);

    this.state = {
      visible: messages.map(() => true)
    };

    messages.forEach((_, index) => {
      setTimeout(() => {
        this.onDismiss(index);
      }, 10000);
    });
  }

  normalizeMessages(props) {
    if (props.messages && Array.isArray(props.messages)) {
      return props.messages;
    }
    // Legacy single message/color support
    return [{ message: props.message, color: props.color }];
  }

  onDismiss(index) {
    this.setState((prevState) => {
      const visible = [...prevState.visible];
      visible[index] = false;
      return { visible };
    });
  }

  render() {
    const { visible } = this.state;
    const messages = this.normalizeMessages(this.props);

    return (
      <div>
        {messages.map(({ message, color }, index) => (
          <AlertBase
            key={index} // eslint-disable-line react/no-array-index-key
            color={color || "success"}
            css={css`
              position: fixed;
              top: calc(15% + ${index * 70}px);
              z-index: 100;
              left: 15%;
              width: 70%;
              box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);
            `}
            isOpen={visible[index]}
            toggle={() => this.onDismiss(index)}
          >
            {message}
          </AlertBase>
        ))}
      </div>
    );
  }
}

Alert.defaultProps = {
  color: "success",
  message: null,
  messages: null
};

Alert.propTypes = {
  color: PropTypes.string,
  message: PropTypes.string,
  messages: PropTypes.arrayOf(
    PropTypes.shape({
      message: PropTypes.string.isRequired,
      color: PropTypes.string
    })
  )
};

export default Alert;
